import { createSlice, PayloadAction } from '@reduxjs/toolkit'

/**
 * The part of presenter mode both windows render from the same store state,
 * so it travels with the rest of it (sync rule `shared`). Everything else of
 * presenter mode belongs to one window and lives in that window's hooks: the
 * console's lifecycle in its state machine, the presentation window's link
 * flags in `useProjectorLink`.
 */
export type PresenterState = {
	/** The projector shows black instead of the stage. Set by the console. */
	blank: boolean
	/**
	 * The audio output the trainer chose for the recordings, which play in
	 * the presentation window; `null` is the system default. Set by the
	 * console, scoped to the running presentation.
	 */
	speakers: string | null
}

const initialState: PresenterState = {
	blank: false,
	speakers: null,
}

const presenterSlice = createSlice({
	name: 'presenter',
	initialState,
	reducers: {
		blankShown: (state, { payload }: PayloadAction<boolean>) => {
			state.blank = payload
		},
		speakersChosen: (state, { payload }: PayloadAction<string | null>) => {
			state.speakers = payload
		},
	},
})

export const presenterActions = presenterSlice.actions
export const presenterReducer = presenterSlice.reducer
